import {Component, Injector, OnInit, signal} from "@angular/core";
import {BasicMaterialDialog, MatDialogDataBaseInput} from "../../basic-material-dialog/basic-material-dialog.directive";
import {ExamSession} from "@models";
import {Translations} from "@translations";

export interface DialogData_ExamFlowSessionsDialogInput extends MatDialogDataBaseInput {
	sessions: ExamSession[];
}

@Component({
	selector: "sim-exam-flow-sessions-dialog",
	templateUrl: "./exam-flow-sessions-dialog.component.html",
	styleUrl: "./exam-flow-sessions-dialog.component.scss",
	standalone: false,
})
export class ExamFlowSessionsDialogComponent
	extends BasicMaterialDialog<ExamFlowSessionsDialogComponent, DialogData_ExamFlowSessionsDialogInput>
	implements OnInit
{
	// Constants
	public readonly T = Translations;

	// Properties
	protected sessions = signal<ExamSession[]>(this.data.sessions);

	public constructor(_injector: Injector) {
		super(_injector);
	}
}
